import { PageLinks } from "./page-links";

export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g,'-');

export const country = defaultArea;

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g,'-');

export const site_name = process.env.GATSBY_SITE_NAME;
export const Bugherd_API_Key = "pomqhu8dp8gq30hoglt0ha";

export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;

export const IsAllAgentReview = true;

export const site_bviewing_agent_id = "";

export const register_link = "https://app.inspectrealestate.co.uk/External/ROL/RegisterProspect.aspx?AgentAccountName=thornleygrovessoutherngateway&type=r"

export const Default_View = "List"

export const epdqID = "epdq1487028";
export const shasign_pass = "e23dcdcb-b6e3-40fc-a95c-4050026ea0d8";

export const search_box_placeholder = "Enter a location e.g. Manchester";

export const footerVatDetails = "Thornley Groves Limited is registered in England & Wales<br />Registered office address: 70 St. Mary Axe, London, EC3A 8BE<br />Registered company number: 02674298. VAT Number: 222469026<br />Part of Lomond";

export const marketing_consent = `I agree to receive property-related news, updates and communications from ${process.env.GATSBY_SITE_NAME}. I understand I can unsubscribe at any time.`

export const terms_text =  `By submitting this form, you confirm that you agree to our website terms and conditions, <a href="/${PageLinks.privacy_policy}/" target="_blank">privacy policy</a> and <a href="/${PageLinks.privacy_policy}/" target="_blank">cookie policy</a>. This site is protected by reCAPTCHA and the Google <a href="/${PageLinks.privacy_policy}/" target="_blank">Privacy Policy</a> and <a href="/${PageLinks.privacy_policy}/" target="_blank">Terms of Service</a> apply.`

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/ThornleyGroves/",
    tw_link: "",
    company_phone: "0161 941 4111",
    available_time: "We're available from 8:30am - 5:30pm Monday to Friday.",
    address: "16/18 Lloyd St, Cheshire, Altrincham WA14 2DE, United Kingdom"
}

// export const PageLinks = {
//     about: "about-thornleygroves",
//     general_enquiry: "general-enquiry",
//     news_insight: `about-thornleygroves/insights`,
//     branch_finder: "about-thornleygroves/branch-finder",
//     area_cover: "about-thornleygroves/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-thornleygroves/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-thornleygroves/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: `financial-services`
// }

export const PropertySearchURL = {
    residential: {
        sales:"/property/for-sale/",
        lettings:"/property/to-rent/",
        newhomes: "/new-homes/for-sale/",
        collection: "/property-collection/for-sale/",
        students:"/property-students/to-rent/",
        investments: "/property-investments/for-sale/",
        prestige: "/property-prestige/for-sale/",
    },
    commercial: {
        sales:"/commercial-property/for-sale/",
        lettings:"/commercial-property/to-rent/",
    },
    auction: {
        sales:"/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales:"/property-for-sale/",
        lettings:"/property-to-rent/",
        newhomes:"/new-homes-for-sale/"
    },
    commercial: {
        sales:"/commercial-property-for-sale/",
        lettings:"/commercial-property-to-rent/",
    },
    auction: {
        sales:"/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales:"Properties for sale",
        lettings:"Properties to rent",
        newhomes:"New developments",
        collection:"Collection properties for sale",
        students:"Student properties for sale",
        investments: "Investment properties for sale",
        prestige: "Prestige properties for sale"
    },
    commercial: {
        sales:"Commercial properties for sale",
        lettings:"Commercial properties to rent",
    },
    auction: {
        sales:"Auction properties for sale"
    }
}

export const PopularSearch_Areas = [ 
    { value: "manchester-and-cheshire", label: "Manchester and Cheshire" },
    { value: "greater-manchester", label: "Greater Manchester" },
    { value: "salford", label: "Salford" },
    { value: "altrincham", label: "Altrincham" }   
]

export const PopularSearch_Types = [ 
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" }   
]

export const sortByList = [ 
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" },
    { value: "Newest", label: "Newest" },
    { value: "Oldest", label: "Oldest" } 
]

export const SearchType = {
    sales:"For Sale",
    lettings:"To Rent",
    newhomes:"New homes",
    investments:"Investments",
    collection:"Collections",
    students:"Students",
    commercial_sales:"Commercial Sales",
    commercial_lettings:"Commercial Lettings",
    auction_sales:"Auctions",
    prestige:"Prestige",
}

export const FurnishedType = [    
    { value: '', label: 'All' },
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const FormsSubject = {
    book_a_valuation_sell:{
        admin_subject:"New Vendor Enquiry",
        user_subject:"Your recent enquiry"
    },
    book_a_valuation_let:{
        admin_subject:"New Landlord Enquiry",
        user_subject:"Your recent enquiry"
    },
    book_a_viewing:{
        admin_subject:"Book a Viewing",
        user_subject:"Your viewing request"
    },
    contact_branch:{
        admin_subject:"Contact",
        user_subject:"Your recent enquiry"
    },
    contact_staff:{
        admin_subject:"Contact",
        user_subject:"Your recent enquiry"
    },
    get_in_touch:{
        admin_subject:"Contact",
        user_subject:"Your recent enquiry"
    },
    newsletter:{ 
        admin_subject:"Newsletter Subscription",
        user_subject:"Thank you for subscribing"
    },
    instant_valuation:{
        admin_subject:"Valuation Request",
        user_subject:"Your valuation request"
    },
    send_to_friend:{
        admin_subject:"Send to a friend",
        user_subject:"Send to a friend"
    }
}

export const leadooPageSlot = {
    sell_property:"Sellers",
    landlords:"Landlords",
    sales:"Sale listings",
    lettings:"",
    branch_finder:"",
    general_enquiry:"General enquiry",
    valuation:"Valuation",
    home:"Valuation"
}